import type { GlobalFieldReference } from '@ps/web-martech-cms-types';
import type { GroupBlock } from '@ps/web-martech-cms-types/Terms';
import classNames from 'clsx';
import React from 'react';

import { CMSHTML, CMSReference } from '@swf/cms';

import styles from './CMSTerms.scss';

const CMSGroupBlock: React.FC<GroupBlock & { index?: number; variant?: string | null }> = ({
  group,
  index,
  variant
}) => {
  const { body, footer, header, title } = group;

  return (
    <div
      className={
        variant
          ? classNames(styles.item, styles[variant as keyof typeof styles])
          : classNames(styles.item)
      }
    >
      {title && index && <div className={styles.title}>{`${index}. ${title}`}</div>}
      {header && <CMSHTML content={header} />}
      {body.map((item, itemIndex) => {
        const [type] = Object.keys(item);
        let groupTitle;
        if (type === 'group') {
          groupTitle = (item as GroupBlock).group.title;
        }
        return (
          <React.Fragment key={itemIndex}>
            {groupTitle ? <strong className={styles.rootBody}>{groupTitle}</strong> : null}
            <div
              key={itemIndex}
              className={classNames(
                index ? styles.gridBlock : styles.block,
                title && index ? styles.rootBody : ''
              )}
            >
              {index ? (
                <div className={styles.number}>{index ? `${index}.${itemIndex + 1}` : ''}</div>
              ) : null}
              {type === 'group' ? (
                <CMSGroupBlock key={itemIndex} variant={null} {...(item as GroupBlock)} />
              ) : (
                <CMSReference key={itemIndex} {...(item as GlobalFieldReference)} />
              )}
            </div>
          </React.Fragment>
        );
      })}
      {footer && <CMSHTML content={footer} />}
    </div>
  );
};

export default CMSGroupBlock;
